<template>
	<div>
		<div class="row">
			<div class="col-md-9">
				<div class="input-group">
					<input
						type="text"
						:placeholder="$t('search-ellipses')"
						v-model="search.q"
						class="form-control form-control-lg"
						@keyup.enter="newSearch"
					/>
					<div class="input-group-append">
						<button class="btn btn-primary" type="button" @click="newSearch">
							<b-icon icon="search"></b-icon>
						</button>
					</div>
				</div>
			</div>
			<div class="col-md-3">
				<router-link class="btn btn-primary btn-block btn-lg mb-3" to="/settings/competencytests/edit">{{ $t('create-new-test') }}</router-link>
			</div>
		</div>

        <b-tabs content-class="mt-3">
        	<b-tab title="Enabled" active lazy @click="getItems">
				<InfiniteScroll
					scrollElementId="main"
					type="CompetencyTest"
					:dataUrl="`${$settings.APIBaseURL}/competencytests/test/list`"
					dataProperty="competencytests"
					class="list-group border-radius-2 no-border"
					itemClass="list-group-item"
					@selectItem="selectItem"
					ref="enabledlist"
				/>        		
        	</b-tab>
        	<b-tab title="Disabled" lazy @click="getItems">
				<InfiniteScroll
					scrollElementId="main"
					type="CompetencyTest"
					:dataUrl="`${$settings.APIBaseURL}/competencytests/test/list`"
					dataProperty="competencytests"
					class="list-group border-radius-2 no-border"
					itemClass="list-group-item"
					@selectItem="selectItem"
					ref="disabledlist"
				/>  
        	</b-tab>
        </b-tabs>

	</div>
</template>

<script>
import InfiniteScroll from "src/components/InfiniteScroll"
export default {
	components: {
		InfiniteScroll		
	},
	data() {
		return {
			search: {
				q: null
			}
		}
	},
	mounted() {
		this.getItems();
	},
	methods: {
		newSearch() {
			this.getItems();
		},
		selectItem(item) {
			this.$store.commit("showBlockingSpinner");
			this.$router.push(`/settings/competencytests/edit/${item.id}`);
		},
		getItems() {

			this.$nextTick(function() {
				if(this.$refs.enabledlist) {
					this.$refs.enabledlist.getData("replace", {
						type: this.$route.params.itemtype,
						q: this.search.q ? this.search.q : ""
					});
				}

				if(this.$refs.disabledlist) {
					this.$refs.disabledlist.getData("replace", {
						type: this.$route.params.itemtype,
						q: this.search.q ? this.search.q : "",
						PublishedState: '10'
					});
				}
			});

		},		
	},
	computed: {

	}
};
</script>
